import * as React from "react";

import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";
import { nameOf } from "../../Utils/nameOf";
import { PdsrOverviewItem } from "../PlantDockSupplierRelations/Overview/PdsrOverviewItem";
import { pdsrClassificationData, spdrClassificationData } from "../RelationClassification";

export function ClassificationColumnMenu({ column, ...restProps }: GridColumnMenuProps) {
  const { field } = column;

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      column={column}
      {...restProps}
      data={
        field && field === nameOf<PdsrOverviewItem>("Classification")
          ? pdsrClassificationData
          : spdrClassificationData
      }
      searchBox={() => null}
    />
  );
}
